module.exports = __webpack_public_path__ + "media/images/new_home/7-marvin-johnson-9b574a27911f4de60285106a0d657336.png";